module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.7be5435e.eot";